export default {
  errors: {
    missing_operator: 'التعبير الرياضي لا يحتوي على عامل رياضي',
    missing_operands: 'التعبير الرياضي يتطلب على الأقل {operandMin} عامل'
  }
}
